export default __webpack_public_path__ + "static/media/try-atomic-transport-displayed.ed4a6ef9.png";